import { render } from "./PartsInterview.vue?vue&type=template&id=c0b3fd4a&scoped=true"
import script from "./PartsInterview.vue?vue&type=script&lang=js"
export * from "./PartsInterview.vue?vue&type=script&lang=js"

import "./PartsInterview.vue?vue&type=style&index=0&id=c0b3fd4a&scoped=true&lang=css"

import exportComponent from "/Users/maru/Desktop/東野材木/hojokin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0b3fd4a"]])

export default __exports__